///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportLocation = Meevo.Plugins.Reports.IReportLocation;

    export class ReportCoreLocationsCollection extends SmartMoverApiCollection<IReportLocation> implements IApiCollection<IReportLocation> {

        protected get url() {
            return 'report/Location';
        }

        constructor(connectedModel: ModelValueType[], items: IReportLocation[] = [], options: ICollectionOptions<IReportLocation> = {}) {
            super(connectedModel, items, options);

            this.updateCriteria({
                coSearchResultFilter: 0,
                coSearchType: 0,
                includeActive: true,
                maintenanceMode: true,
                businessTypeList: []
            });
        }
    }

}
